module.exports = __webpack_public_path__ + "media/images/videos/suns-long-ver-3fb486fb2ee3a27f78983cbc034cb565.mp4";